module.exports = __webpack_public_path__ + "img/lala_scroll08.6eed54ea.webp";